export default __webpack_public_path__ + "static/char-s-39-en-6d8d5da820e45392c101878f5a304642.webp";